import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { toast, Toaster } from "react-hot-toast";
import Api from "../Api/Api.json";
import Card from "../components/Container/Card";
import ProgressBar from "../components/ProgressBar";
import TextArea from "../components/Input/TextArea";
import Button from "../components/Button/Button";
import LoadingIcon from "../components/Icons/LoadingIcon";
import PrintIcon from "../components/Icons/PrintIcon";
import RestartIcon from "../components/Icons/RestartIcon";
import MainContainer from "../components/Container/MainContainer";

let userid = 0;
let gender = "";
let age = 0;

const PregnancyRealTimeRiskEvalIntake = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      age: "",
      gender: "",
      q1: "আজকে আপনার কি সমস্যা আছে?",
      q2: "",
      q3: "",
      q4: "",
      q5: "",
      q6: "",
      q7: "",
      q8: "",
      q9: "",
      q10: "",
      a1: "",
      a2: "",
      a3: "",
      a4: "",
      a5: "",
      a6: "",
      a7: "",
      a8: "",
      a9: "",
      a10: "",
    },
  });

  const [currentIndex, setCurrentIndex] = useState(1);
  const [isComplete, setIsComplete] = useState(false);
  const [prescription, setPrescription] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // We'll use watch to get current form data
  const formData = watch();

  useEffect(() => {
    if (localStorage.getItem("user_info") !== null) {
      userid = JSON.parse(localStorage.getItem("user_info")).di_id;
      gender = JSON.parse(localStorage.getItem("user_info")).gender;
      if (gender === "M") {
        gender = "পুরুষ";
      } else {
        gender = "মহিলা";
      }
      age = JSON.parse(localStorage.getItem("user_info")).age;
      setValue("age", age);
      setValue("gender", gender);
      console.log(gender);
      console.log(age);
    }
  }, [setValue]);

  const processNextQuestion = async (data) => {
    if (currentIndex === 10) {
      setIsComplete(true);
      return;
    }

    setIsLoading(true);

    // Send collected responses to API to get next question
    const requestData = {
      task: "getNextQuestionForPregnancyEmergency",
      formData: data,
      patient_id: userid,
    };

    console.log(requestData);
    const headers = { headers: { "Content-Type": "application/json" } };
    const url = Api.PREGNANCY_DATA_API;

    try {
      const response = await axios.post(url, requestData, headers);
      console.log(response.data);
      const responseObject = JSON.parse(response.data);

      if ("risk_factors" in responseObject) {
        console.log(response.data);
        setIsComplete(true);
        toast.success("ফর্ম সাবমিট করা হয়েছে!");
      } else {
        setValue(`q${currentIndex + 1}`, responseObject.question || "");
        setCurrentIndex(currentIndex + 1);
        toast.success("পরবর্তী প্রশ্নে যাওয়া হয়েছে!");
      }
    } catch (e) {
      console.log(e);
      toast.error("কিছু সমস্যা হয়েছে। আবার চেষ্টা করুন!");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrint = () => {
    const printContent = document.getElementById("printable-section").innerHTML;
    console.log(printContent);

    const parser = new DOMParser();
    const doc = parser.parseFromString(printContent, "text/html");

    const elementToRemove = doc.getElementById("dont-print");
    if (elementToRemove) {
      elementToRemove.remove();
    }

    const cleanedPrintContent = doc.body.innerHTML;
    console.log(cleanedPrintContent);

    const newWindow = window.open("", "", "width=800,height=600");
    newWindow.document.write(`
        <html>
            <head>
                <title>Print Summary</title>
                <style>
                    body { font-family: Arial, sans-serif; padding: 20px; }
                    h2 { text-align: center; }
                    ul { list-style-type: disc; margin-left: 20px; }
                </style>
            </head>
            <body>
                ${cleanedPrintContent}
            </body>
        </html>
    `);

    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.close();

    toast.success("প্রিন্ট করা হচ্ছে!");
  };

  const handleRefresh = () => {
    reset({
      age: "",
      gender: "",
      q1: "আজকে আপনার কি সমস্যা আছে?",
      q2: "",
      q3: "",
      q4: "",
      q5: "",
      q6: "",
      q7: "",
      q8: "",
      q9: "",
      q10: "",
      a1: "",
      a2: "",
      a3: "",
      a4: "",
      a5: "",
      a6: "",
      a7: "",
      a8: "",
      a9: "",
      a10: "",
    });
    setCurrentIndex(1);
    setIsComplete(false);
    setPrescription(null);
    toast.success("ফর্ম রিসেট করা হয়েছে!");
  };

  return (
    <MainContainer background="bg-gray-50" className="pt-14">
      <Toaster position="top-center" />
      <div className="max-w-xl mx-auto p-6">
        <Card id="printable-section" className="bg-white overflow-hidden">
          {/* Header */}
          <div className="bg-rose-600 text-white p-4">
            <h1 className="text-2xl font-bold text-center">
              গর্ভকালীন স্বাস্থ্য ঝুঁকি মূল্যায়ন
            </h1>
          </div>

          <div className="p-6">
            {!isComplete ? (
              <div className="space-y-6">
                <ProgressBar totalSteps={10} currentStep={currentIndex} />

                {/* Question Number */}
                <div>
                  <span className="bg-rose-100 text-rose-800 text-sm font-medium px-3 py-1 rounded-full">
                    প্রশ্ন {currentIndex}/10
                  </span>
                </div>

                {/* Question */}
                <div className="bg-rose-50 p-4 rounded-lg border border-rose-100">
                  <p className="text-lg font-medium text-gray-800">
                    {formData[`q${currentIndex}`]}
                  </p>
                </div>

                {/* Answer Input */}
                <div className="relative">
                  <TextArea
                    id={`a${currentIndex}`}
                    placeholder="আপনার উত্তর..."
                    register={register(`a${currentIndex}`, {
                      required: "উত্তর দেওয়া আবশ্যক!",
                    })}
                    errors={errors}
                  />
                </div>

                {/* Navigation Button */}
                <Button
                  type="button"
                  disabled={isLoading}
                  onClick={handleSubmit(processNextQuestion)}
                  icon={isLoading ? <LoadingIcon /> : false}
                  label={currentIndex === 10 ? "সম্পূর্ণ করুন" : "পরবর্তী"}
                  rounded="rounded-lg"
                  width="w-full"
                  backgroundColor="bg-rose-600"
                  hoverBackgroundColor="hover:bg-rose-700"
                  textColor="text-white"
                />
              </div>
            ) : (
              <div className="space-y-6">
                <Card className="bg-green-100 p-4 border border-green-200 mb-6">
                  <h2 className="text-xl font-semibold text-green-800 mb-2">
                    প্রশ্নোত্তর সম্পন্ন হয়েছে
                  </h2>
                  <p className="text-green-700">
                    আপনার স্বাস্থ্য ঝুঁকি প্রশ্নোত্তর জমা হয়েছে। আপনার ডাক্তার
                    সমস্যাটি দেখবেন।
                  </p>
                </Card>

                <div className="space-y-6">
                  <h3 className="text-lg font-medium text-gray-800 border-b pb-2">
                    আপনার প্রদত্ত তথ্য
                  </h3>

                  {Object.keys(formData).map((key, index) => {
                    if (key.startsWith("q") && formData[key]) {
                      const answerKey = "a" + key.substring(1);
                      return (
                        <div
                          key={index}
                          className="border-b border-gray-200 pb-4"
                        >
                          <p className="font-medium text-gray-700">
                            {formData[key]}
                          </p>
                          <p className="mt-2 text-gray-600 pl-3 border-l-2 border-rose-300">
                            {formData[answerKey] || "(উত্তর দেওয়া হয়নি)"}
                          </p>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>

                <div id="dont-print" className="flex space-x-4 pt-4">
                  <Button
                    type="button"
                    onClick={handlePrint}
                    icon={<PrintIcon />}
                    label="প্রিন্ট করুন"
                    rounded="rounded-lg"
                    backgroundColor="bg-blue-600"
                    hoverBackgroundColor="hover:bg-blue-700"
                    textColor="text-white"
                    className="flex-1"
                  />

                  <Button
                    type="button"
                    onClick={handleRefresh}
                    icon={<RestartIcon />}
                    label="পুনরায় শুরু করুন"
                    rounded="rounded-lg"
                    backgroundColor="bg-rose-600"
                    hoverBackgroundColor="hover:bg-rose-700"
                    textColor="text-white"
                    className="flex-1"
                  />
                </div>
              </div>
            )}
          </div>
        </Card>
      </div>
    </MainContainer>
  );
};

export default PregnancyRealTimeRiskEvalIntake;
